// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromString(value) {
  switch (value) {
    case "Customer" :
        return /* Customer */0;
    case "CustomerReceiver" :
        return /* CustomerReceiver */3;
    case "CustomerSender" :
        return /* CustomerSender */2;
    case "Partner" :
        return /* Partner */1;
    case "Unverified" :
        return /* Unverified */4;
    default:
      return ErrorUtils$Catalyst.raiseError("UserProfileTypeType.res", "Invalid user profile", value);
  }
}

function toString(value) {
  switch (value) {
    case /* Customer */0 :
        return "Customer";
    case /* Partner */1 :
        return "Partner";
    case /* CustomerSender */2 :
        return "CustomerSender";
    case /* CustomerReceiver */3 :
        return "CustomerReceiver";
    case /* Unverified */4 :
        return "Unverified";
    
  }
}

function displayString(value) {
  switch (value) {
    case "Customer" :
        return "Customer";
    case "CustomerReceiver" :
        return "Customer (RECEIVER)";
    case "CustomerSender" :
        return "Customer (SENDER)";
    case "Partner" :
        return "Partner";
    case "Unverified" :
        return "Unverified";
    default:
      return ErrorUtils$Catalyst.raiseError("UserProfileType.res", "Invalid user profile display string", value);
  }
}

var user_profile = {
  hd: /* Customer */0,
  tl: {
    hd: /* Partner */1,
    tl: {
      hd: /* CustomerSender */2,
      tl: {
        hd: /* CustomerReceiver */3,
        tl: {
          hd: /* Unverified */4,
          tl: /* [] */0
        }
      }
    }
  }
};

export {
  user_profile ,
  fromString ,
  toString ,
  displayString ,
  
}
/* No side effect */
